import { GridColDef } from '@mui/x-data-grid';
import Table from '../custom/Table';
import Title from '../custom/Title';
import DynamicForm from '../forms/DynamicForm';
import { SEARCH_TRADE_BLOTTER_FIELDS, TRADE_BLOTTER_BU_TRADES_FIELDS, TRADE_BLOTTER_HEDGE_TRADES_FIELDS } from '../../Models/BlotterTables';
import CustomTabs from '../custom/Tabs';

export const TradeBlotter = () => {

    return (
        <div style={{ padding: '0 10px' }}>
            <div style={{ borderBottom: '1px solid #d8d8d8' }}>
                <Title style={{ textAlign: 'left', margin: '20px 10px 10px 10px', color: '#7f7d76' }}>Trade Blotter</Title>
            </div>
            <CustomTabs
                labels={[
                    'BU Trades',
                    'Hedge Trades',
                ]}
                TabContents={[
                    <BUTradeBlotter />,
                    <HedgeTradeBlotter />
                ]}
            />
        </div>
    )
}

const BUTradeBlotter = () => {

    const config = SEARCH_TRADE_BLOTTER_FIELDS

    const getBuTradeBlotterColumns = (): GridColDef<any>[] => {
        let minWidth = 100
        return TRADE_BLOTTER_BU_TRADES_FIELDS.map(inboundField => {
            switch (inboundField.id) {
                case "dealtPriceCpLeg1Fld":
                    minWidth = 160
                    break;
                case "dealtPriceCpLeg2":
                    minWidth = 160
                    break;
                case "physicalOrderNo":
                    minWidth = 160
                    break;
                case "marketPriceCpLeg1":
                    minWidth = 160
                    break;
                case "marketPriceCpLeg2":
                    minWidth = 160
                    break;
                case "platformName":
                    minWidth = 140
                    break;

                default:
                    minWidth = 100
                    break;
            }

            return {
                field: inboundField.id,
                headerName: inboundField.label,
                minWidth
            }
        })
    }

    const buTradeRows = [{ id: 1 }]
    const submitHandler = (data: any): any => {
    }
    return (
        <div>
            <div style={{ padding: '20px 0px' }}>
                <DynamicForm config={config} onSubmit={submitHandler} submitText='Search' onCancel={() => { }} cancelText='Clear Filter' />
            </div>
            <Table columns={getBuTradeBlotterColumns()} rows={buTradeRows} />
        </div>
    )
}

const HedgeTradeBlotter = () => {

    const config = SEARCH_TRADE_BLOTTER_FIELDS

    const getHedgeTradeBlotterColumns = (): GridColDef<any>[] => {
        let minWidth = 100
        return TRADE_BLOTTER_HEDGE_TRADES_FIELDS.map(inboundField => {
            switch (inboundField.id) {
                case "platformName":
                    minWidth = 140
                    break;
                default:
                    minWidth = 100
                    break;
            }

            return {
                field: inboundField.id,
                headerName: inboundField.label,
                minWidth
            }
        })
    }

    const HedgeTradeRows = [{ id: 1 }]
    const submitHandler = (data: any): any => {
    }
    return (
        <div>
            <div style={{ padding: '20px 0px' }}>
                <DynamicForm config={config} onSubmit={submitHandler} submitText='Search' onCancel={() => { }} cancelText='Clear Filter' />
            </div>
            <Table columns={getHedgeTradeBlotterColumns()} rows={HedgeTradeRows} />
        </div>
    )
}
